document.addEventListener('DOMContentLoaded', () => {
  const zoom = 2.6;

  const lens = document.createElement('div');
  lens.className = 'circle-zoom-lens';
  document.body.appendChild(lens);

  document.querySelectorAll('media-gallery .product-media-container--image').forEach((container) => {
    const img = container.querySelector('img');
    if (!img) return;

    container.style.position = 'relative';

    const imageWrapper = img.closest('.product-media') || img.parentElement || container;
    imageWrapper.style.position = 'relative';

    // Desactiva zoom nativo Horizon
    container.removeAttribute('on:click');
    container.querySelectorAll('[on\\:click]').forEach((el) => el.removeAttribute('on:click'));
    container.querySelectorAll('.product-media-container__zoom-button').forEach((el) => el.remove());

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'circle-zoom-toggle';
    button.setAttribute('aria-label', 'Activar zoom');

    button.innerHTML = `
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <circle cx="11" cy="11" r="7"></circle>
        <line x1="16.5" y1="16.5" x2="21" y2="21"></line>
      </svg>
    `;

    imageWrapper.appendChild(button);

    let active = false;

    const setLensImage = () => {
      const imageUrl = img.currentSrc || img.src;
      lens.style.backgroundImage = `url("${imageUrl}")`;
      lens.style.backgroundSize = `${img.clientWidth * zoom}px ${img.clientHeight * zoom}px`;
    };

    const closeZoom = () => {
      active = false;
      lens.classList.remove('is-visible');
      button.classList.remove('is-active');
      document.body.classList.remove('circle-zoom-lock');
    };

    const moveLens = (clientX, clientY) => {
      if (!active) return;

      const rect = img.getBoundingClientRect();

      if (clientX < rect.left || clientX > rect.right || clientY < rect.top || clientY > rect.bottom) {
        lens.classList.remove('is-visible');
        return;
      }

      const x = clientX - rect.left;
      const y = clientY - rect.top;
      const lensRadius = lens.offsetWidth / 2;

      lens.style.left = `${clientX}px`;
      lens.style.top = `${clientY}px`;
      lens.style.backgroundPosition = `-${x * zoom - lensRadius}px -${y * zoom - lensRadius}px`;
      lens.classList.add('is-visible');
    };

    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      active = !active;
      button.classList.toggle('is-active', active);
      document.body.classList.toggle('circle-zoom-lock', active);

      if (active) {
        setLensImage();
      } else {
        lens.classList.remove('is-visible');
      }
    }, true);

    img.addEventListener('mousemove', (event) => {
      moveLens(event.clientX, event.clientY);
    });

    img.addEventListener('mouseleave', () => {
      lens.classList.remove('is-visible');
    });

    img.addEventListener('touchmove', (event) => {
      if (!active) return;

      event.preventDefault();

      const touch = event.touches[0];
      if (!touch) return;

      moveLens(touch.clientX, touch.clientY);
    }, { passive: false });

    img.addEventListener('touchend', () => {
      closeZoom();
    });
  });
});